import { get } from "lodash";

export default state => {
  try {
    return get(state, ["debtor", "receivablesEntries", "loading"], false);
  } catch (err) {
    return false;
  }
};
